var React = require('react');

function Announcement (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.444 11.005a.505.505 0 0 1-.493.514h-.677a.505.505 0 0 1-.493-.514V.513c0-.282.222-.513.493-.513h.677c.271 0 .493.231.493.513v10.492zM14 5.52c0 1.187-.924 2.15-2.063 2.15v-4.3c1.14 0 2.063.962 2.063 2.15zM9.289.545v10.428c-1.94-2.021-6.313-2.567-6.313-2.567V3.112S7.35 2.567 9.29.545zM1.252 3.214h1.232v5.091H1.149v-.009C.51 8.251 0 7.698 0 7.021V4.497c0-.676.51-1.23 1.15-1.274v-.01h.101zm1.1 8.142a.632.632 0 0 1-.618.644.632.632 0 0 1-.62-.644c0-.158.053-.303.144-.415.057-.195.107-.41.114-.52.012-.24-.156-.963-.156-.963v-.64h1.222v.64s-.261.708-.249.943c.006.116-.037.341.022.544a.657.657 0 0 1 .142.411z","fill":"#424242"}));
}

Announcement.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12"};

module.exports = Announcement;

Announcement.default = Announcement;
